<template>
  <v-text-field
    v-model="search_text"
    id="explorerHeaderSearchableText"
    name="explorerHeaderSearchableText"
    ref="explorerHeaderSearchableText"
    placeholder="Search..."
    single-line
    @input="isTyping = true"
    class="explorer-table-searchable-text mr-0"
    background-color="#f2f2f2"
    color="$acacac"
    solo
    flat
    clearable
    dense
    filled
    hide-details	

  >
    <v-icon
      slot="append"
      class="explorer-table-searchable-icon"
    >
      mdi-magnify
    </v-icon>
  </v-text-field>
</template>

<script>
 /* import _ from 'lodash'; */
 import debounce from 'lodash/debounce';

 export default {
   name: 'SearchText',
   data() { 
     return {
       isTyping: false,
       search_text: '',
       searchClosed: true,
     }
   },
   watch: {
     // launch when stop typing wait 1s.
     search_text: debounce(function() {
       this.isTyping = false;
     }, 1000), 

     isTyping: function(value) {
       if (!value) {
         if (this.search_text && this.search_text.length >= 3) this.$emit("input", this.search_text);
         if (!this.search_text) this.$emit("input", '')
       }
     }
   },
 }
</script>
